import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Injectable({ providedIn: 'root' })
export class LanguageService {
  public defaultLanguage = 'ru';
  public languages: string[] = ['ru', 'uz', 'ka', 'ka-latn', 'uz-latn', 'en'];

  constructor(public translate: TranslateService) {
  }
  titleCase(word: string) {
    word = word.toLocaleLowerCase();
    const langWords = word.split('-');
    let result = '';
    for (let index = 0; index < langWords.length; index++) {
      let element = langWords[index];
      element[0].toUpperCase()
      result += element[0].toUpperCase() + element.slice(1);
    }
    return result;
  }

  public init() {
    let browserLang;
    this.translate.addLangs(this.languages);

    if (localStorage.getItem('lang')) {
      browserLang = localStorage.getItem('lang');
    } else {
      browserLang = this.translate.getBrowserLang();
    }
    this.translate.use(browserLang.match(/ru|uz/) ? browserLang : this.defaultLanguage);
  }

  public setLanguage(lang) {
    // if(lang==='uz')
    // lang='en'
    this.translate.reloadLang(lang);
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  public get currentLanguage() {
    return this.translate.currentLang;
  }

  public get fieldSuffix() {

    if (!this.currentLanguage) {
      return this.defaultLanguage === 'ru' ? '' : this.titleCase(this.defaultLanguage);
    }
    else {
      return this.currentLanguage === 'ru' ? '' : this.titleCase(this.currentLanguage);
    }

  }
}
